import { API_PDC_URL_V1 } from "../../../../config";
import { callWithRetry } from "../../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../../services/http-header";

export const preferencesConstants = {
  UPDATE_NOTIFY_PREFERENCES_START: "UPDATE_NOTIFY_PREFERENCES_START",
  UPDATE_NOTIFY_PREFERENCES_ERROR: "UPDATE_NOTIFY_PREFERENCES_ERROR",
  UPDATE_NOTIFY_PREFERENCES_SUCCESS: "UPDATE_NOTIFY_PREFERENCES_SUCCESS",

  GET_NOTIFY_PREFERENCES_START: "GET_NOTIFY_PREFERENCES_START",
  GET_NOTIFY_PREFERENCES_ERROR: "GET_NOTIFY_PREFERENCES_ERROR",
  GET_NOTIFY_PREFERENCES_SUCCESS: "GET_NOTIFY_PREFERENCES_SUCCESS"
};

export function updateNotifyPreferences(
  auth, ncsId, channels, templates
) {
  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: preferencesConstants.UPDATE_NOTIFY_PREFERENCES_START
      });

      let bodyRequest = { channels: channels, templateTypes: templates };

      let request = {
        method: "PUT",
        url: API_PDC_URL_V1 + "/subjects/" + ncsId + "/preferences",
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: bodyRequest
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: preferencesConstants.UPDATE_NOTIFY_PREFERENCES_SUCCESS,
            payload: { ...response.data, ...bodyRequest }
          });
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: preferencesConstants.UPDATE_NOTIFY_PREFERENCES_ERROR,
            payload: { error: err }
          });
          reject(err);
        });
    });
  };
}

export function getNotifyPreferences(auth, ncsId) {
  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: preferencesConstants.GET_NOTIFY_PREFERENCES_START
      });

      let request = {
        method: "GET",
        url: API_PDC_URL_V1 + "/subjects/" + ncsId + "/preferences",
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: preferencesConstants.GET_NOTIFY_PREFERENCES_SUCCESS,
            payload: { ...response.data }
          });
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: preferencesConstants.GET_NOTIFY_PREFERENCES_ERROR,
            payload: { error: err }
          });
          reject(err);
        });
    });
  };
}
